module.exports = __webpack_public_path__ + "assets/img/title-58536904.png";